import React, { useEffect, useState } from "react";
import { AuthNav } from "../../../components/Navbar/Webpages/AuthNav";
import { SideNav } from "../../../components/Navbar/Webpages/AuthNav";
import { PlanCard } from "../../../components/Cards/Plans";
import { useDispatch, useSelector } from "react-redux";
import { getPlansRequest } from "../../../redux/action";
import toast from "react-hot-toast";
import { CircularProgress } from "@material-ui/core";

const Plans = () => {
  const dispatch = useDispatch();

  const { getPlansSuccess, getPlansError, getPlansLoading, user, plans } =
    useSelector((state) => {
      const {
        success: { getPlans: getPlansSuccess },
        errors: { getPlans: getPlansError },
      } = state.ajaxStatuses;

      const { getPlansLoading } = state.loadingIndicator;

      const { user } = state.userData;
      const { plans } = state.planData;

      return {
        getPlansSuccess,
        getPlansError,
        getPlansLoading,
        user,
        plans,
      };
    });

  useEffect(() => {
    if (getPlansError) {
      toast.error(getPlansError, {
        duration: 3000,
      });
    }
  }, [getPlansError]);

  useEffect(() => {
    dispatch(getPlansRequest());
  }, [getPlansRequest]);

  return (
    <div className=" h-screen overflow-y-auto">
      <AuthNav title={"Investment"} />
      <SideNav />
      <div>
        <div className="container max-w-screen-xl mx-auto px-3 pt-20">
          <div className="text-center mb-16">
            <h1 className="text-xl md:text-4xl font-bold font-heading text-gray-900 mb-6 leading-tight">
              Choose Your
              <span className="bg-gradient-to-r from-primary to-purple-600 bg-clip-text text-transparent">
                {" "}
                Investment{" "}
              </span>
              Journey
            </h1>
            <p className="font-body text-sm md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Start building wealth with our carefully crafted investment plans.
              Each plan is designed to maximize your returns while managing
              risk.
            </p>
          </div>

          {/* Plans Grid */}
          <div className="relative">
            {getPlansLoading ? (
              <div className="flex justify-center items-center py-32">
                <div className="text-center">
                  <CircularProgress style={{ color: "#3B82F6" }} size="40px" />
                  <p className="text-gray-600 mt-4 font-medium">
                    Loading investment plans...
                  </p>
                </div>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
                {plans.map((plan, index) => (
                  <PlanCard plan={plan} key={index} index={index} />
                ))}
              </div>
            )}
          </div>

          {/* Bottom CTA Section */}
          <div className="mt-20 text-center">
            <div className="bg-gradient-to-r from-primary-600 to-purple-600 rounded-2xl p-8  max-w-4xl mx-auto">
              <h3 className="text-2xl font-bold mb-4">
                Ready to Start Investing?
              </h3>
              <p className="text-primary-100 mb-6">
                Join thousands of investors who trust us with their financial
                future
              </p>
              <div className="flex flex-wrap justify-center gap-4 text-sm">
                <div className="flex items-center">
                  <span className="w-2 h-2 bg-green-400 rounded-full mr-2"></span>
                  Secure & Regulated
                </div>
                <div className="flex items-center">
                  <span className="w-2 h-2 bg-green-400 rounded-full mr-2"></span>
                  24/7 Support
                </div>
                <div className="flex items-center">
                  <span className="w-2 h-2 bg-green-400 rounded-full mr-2"></span>
                  Instant Withdrawals
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Plans;
